import { AnswerType } from 'shared/domain/checklistAnswer/types/answerType';
import { ComplianceAnswerOption } from 'shared/domain/compliance/complianceAnswerOption';
import { ProtocolItemModel } from 'shared/domain/inspection/inspectionModel';
import { findProtocolAnswerByChecklistAnswerId } from 'shared/domain/protocolAnswer/findProtocolAnswerByChecklistAnswerId';
import {
  ProtocolAnswerApplicabilityUpdateOutDto,
  ProtocolAnswerUpdateOutDto,
} from 'shared/dtos/out/protocolAnswer';
import {
  isRichTextEmpty,
  toPersistedRichTextHtml,
} from 'shared/utils/richText';

function normalizedTextValue(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const sanitized = toPersistedRichTextHtml(value);
  return isRichTextEmpty(sanitized) ? null : sanitized;
}

export function buildProtocolAnswerUpdateOutDto(
  answerType: AnswerType,
  value: unknown
): ProtocolAnswerUpdateOutDto | null {
  switch (answerType) {
    case AnswerType.Compliance:
      return {
        type: AnswerType.Compliance,
        selectedOption: value as ComplianceAnswerOption,
      };
    case AnswerType.Numeric:
      return {
        type: AnswerType.Numeric,
        numericValue: value as number | undefined,
      };
    case AnswerType.Text:
      return {
        type: AnswerType.Text,
        textValue: normalizedTextValue(value),
      };
    case AnswerType.OptionSelection:
      return {
        type: AnswerType.OptionSelection,
        selectedOptionIds: value as string[],
      };
    default:
      return null;
  }
}

export function buildProtocolAnswerApplicabilityUpdateOutDto(
  answerType: AnswerType,
  isApplicable: boolean
): ProtocolAnswerApplicabilityUpdateOutDto {
  return {
    type: answerType,
    isApplicable,
  };
}

export function findProtocolAnswerId(
  protocolItem: ProtocolItemModel | undefined,
  checklistAnswerId: string
): string | undefined {
  return findProtocolAnswerByChecklistAnswerId(
    protocolItem?.answers,
    checklistAnswerId
  )?._id;
}
